import styled from "styled-components";

const SvgIcon = styled.svg`
  fill: #a0a0a0;
  cursor: pointer;
  transform: scale(2.5);
  margin: 20px;

  &:hover {
    fill: #191509;
  }
`;

export default SvgIcon;
